import { Component, effect, EventEmitter, inject, Input, Output } from '@angular/core';
import { CurrencyPipe, NgClass, NgIf } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { DrawerBreadcrumbComponent } from '../../drawer-breadcrumb/drawer-breadcrumb.component';
import { MatIcon } from '@angular/material/icon';
import { OpenQuoteRequestsItem } from '../../quote-requests.types';
import { MainFuseDrawerService } from '../../../../main-fuse-drawer/main-fuse-drawer.service';

@Component({
  selector: 'sbd-account-portal-frontend-purchase-steps-wrapper',
  standalone: true,
  imports: [
    CurrencyPipe,
    MatButton,
    MatDivider,
    NgIf,
    DrawerBreadcrumbComponent,
    MatIconButton,
    MatIcon,
    NgClass,
  ],
  templateUrl: './purchase-steps-wrapper.component.html'
})
export class PurchaseStepsWrapperComponent {
  @Input() step = 1;
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;

  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Output() moveBackEvent = new EventEmitter<void>();
  @Output() moveToNextStepEvent = new EventEmitter<void>();
  @Input() showCloseButton = true;

  isPurchased = false;
  isPurchasing = false;
  recentlyPurchasedCount = 0;
  _mainFuseDrawerService = inject(MainFuseDrawerService)
  subtotal = 0;
  shippingTotal = 0;
  total = 0;
  queuedQR: OpenQuoteRequestsItem[] = [];
  showStepsHeader: any;

  constructor() {
    effect(() => {
      this.isPurchased = this._mainFuseDrawerService.isPurchased();
      this.isPurchasing = this._mainFuseDrawerService.isPurchasing();
      this.recentlyPurchasedCount = this._mainFuseDrawerService.recentlyPurchasedCount();
      this.showStepsHeader = this._mainFuseDrawerService.showStepsHeader();
      this.shippingTotal = this._mainFuseDrawerService.shippingTotal();
      this.subtotal = this._mainFuseDrawerService.subtotal();
      this.total = this._mainFuseDrawerService.total();
      this.queuedQR = this._mainFuseDrawerService.queuedQR();
    });
  }


  onCloseDrawer() {
    this.closeDrawerEvent.emit();
  }

  onMoveBack() {
    this.moveBackEvent.emit();
  }

  onMoveToNextStep() {
    this.moveToNextStepEvent.emit();
  }


}
